import { FiltroTermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/components/FiltroTermoNotificacao/FiltroTermoNotificacao";
import { ItemListSaneamento } from "@/contexts/fiscalizacao/termoNotificacao/components/ItemListSaneamento/ItemListSaneamento";
import { useTermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/hooks/useTermoNotificacao";
import { useNetworkStatus } from "@/shared/hooks/useNetworkStatus";
import { formatMessageError } from "@/shared/utils/formatMessageError";
import { useQuery } from "@tanstack/react-query";
import { App, Divider, Grid, List, Result } from "antd";
import { Typography } from "antd/lib";
import { useEffect } from "react";
import { useSearchParams } from "react-router";

const PAGE_SIZE = 20;

export function SaneamentoTermosNotificacao() {
  const screens = Grid.useBreakpoint();
  const { isOnline } = useNetworkStatus();
  const [searchParams, setSearchParams] = useSearchParams();
  const { getTermosNotificacaoApi } = useTermoNotificacao();
  const { notification } = App.useApp();
  const page = searchParams.get("page") || "1";
  const currentPage = Number(page);

  const {
    data: listaTermos,
    isLoading: isLoadingList,
    error: errorList,
  } = useQuery({
    queryKey: ["TERMOS_NOTIFICACAO", searchParams.toString()],
    enabled: isOnline && !!searchParams.get("estabelecimentoId"),
    queryFn: async () => {
      const response = await getTermosNotificacaoApi({
        estabelecimentoId: Number(searchParams.get("estabelecimentoId")),
        dataCadastro: searchParams.get("dataCadastro") || undefined,
        numero: searchParams.get("numero") || undefined,
        page: currentPage,
        status: searchParams.get("status") || undefined,
      });
      return response;
    },
  });

  useEffect(() => {
    document.title = "Inspeção Mobile - Plano de Ação de Termos de Notificação";

    if (errorList) {
      const messageError = formatMessageError(errorList);
      notification.error({
        message: "Não foi possivel carregar a lista de termos de notificação.",
        description: messageError,
        key: "error-filtro",
      });
    }
  }, [errorList]);

  if (!isOnline) {
    return <Result title="Sem conexão com a internet" status={"error"} />;
  }

  return (
    <>
      <Typography.Title
        level={screens.xs ? 4 : 3}
        style={{ textAlign: "center" }}
      >
        Planos de Ação de Termos de Notificação
      </Typography.Title>

      <Divider />

      <FiltroTermoNotificacao />

      <Divider>
        <Typography.Text strong>Resultados da busca</Typography.Text>
      </Divider>
      <List
        size="small"
        bordered
        dataSource={listaTermos?.content || []}
        renderItem={(item, index) => (
          <ItemListSaneamento key={index} item={item} />
        )}
        loading={isLoadingList}
        pagination={{
          pageSize: PAGE_SIZE,
          position: "bottom",
          defaultCurrent: 1,
          current: Number(page),
          total: listaTermos?.totalElements || 0,
          showSizeChanger: false,
          onChange: (page) => {
            searchParams.set("page", String(page));
            setSearchParams(searchParams);
          },
          align: "end",
          size: "small",
        }}
      />
    </>
  );
}
